import React from 'react';

import { HeaderSection } from './header-section';
import { SegmentList } from './segment-list';

export const Transcript = () => {
  return (
    <div className="flex flex-col gap-3 h-full">
      <HeaderSection />
      <SegmentList />
    </div>
  );
};
